import React, { useEffect, useState } from "react";
import { NovletiesTableRow } from "./novletiesTableRow";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const NoveltiesTable = ({
	documents,
	setDocumentToEdit,
	// setDocumentToDelete,
	deleteDocument,
	openModal1,
	// openModal2,
	setShowNovelties,
}) => {
	const [data, setData] = useState(documents);
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);

	useEffect(() => {
		setData(documents);
	}, [documents]);

	function handleSearch(e) {
		if (e.target.value === "") {
			return setData(documents);
		}
		setData(
			documents.filter(
				(item) =>
					item.employeeDocument.toLowerCase().includes(e.target.value) ||
					item.employeeName.toLowerCase().includes(e.target.value) ||
					item.noveltyName.toLowerCase().includes(e.target.value)
			)
		);
	}
	const exportToExcel = () => {
		const transformedData = data.map((item) => ({
			"Nombre del empleado": item.employeeName,
			"Documento del empleado": item.employeeDocument,
			Novedad: item.noveltyName,
			Comentario: item.comment?.replace(/\n/g, " "), // quitar saltos de línea
			"Fecha de creación": item.dateCreation,
			"Fecha inicial": item.dateInitial,
			"Fecha final": item.dateFinal,
			"Archivo adjunto": item.name_Doc_Novedad,
			"Enlace al documento": item.Doc_Novedad,
			"Usuario que creó": item.userCreation,
		}));

		const worksheet = XLSX.utils.json_to_sheet(transformedData);
		const workbook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(workbook, worksheet, "Novedades");

		const excelBuffer = XLSX.write(workbook, {
			bookType: "xlsx",
			type: "array",
		});

		const dataBlob = new Blob([excelBuffer], {
			type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
		});
		saveAs(dataBlob, "novedades.xlsx");
	};

	return (
		<div>
			{/* {console.log("data", data)} */}
			<h3 className="titulo1">Lista de Novedades:</h3>

			{console.log(data)}
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					name=""
					id=""
					onChange={handleSearch}
					className="search-box"
				/>
			</div>
			<button onClick={exportToExcel} className="btnEportExel">
				📥 Exportar a Excel
			</button>
			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						<th className="titleTableDocuments03">Creación</th>
						<th className="titleTableDocuments01">Nombre</th>
						<th className="titleTableDocuments03">Documento</th>
						<th className="titleTableDocuments01">Novedad</th>
						<th className="titleTableDocuments03">Fecha Inicial</th>
						<th className="titleTableDocuments03">Fecha Final</th>
						{localUser.type === "3" &&
							localUser.area === "Recursos Humanos" && (
								<th className="titleTableDocuments03">Acción</th>
							)}
						{localUser.type === "3" &&
							localUser.area === "Recursos Humanos" && (
								<th className="titleTableDocuments03">Borrar</th>
							)}
					</tr>
				</thead>
				<tbody>
					{data && data.length > 0 ? (
						data.map((el) => (
							<NovletiesTableRow
								key={el.id}
								el={el}
								setDocumentToEdit={setDocumentToEdit}
								// setDocumentToDelete={setDocumentToDelete}
								deleteDocument={deleteDocument}
								openModal1={openModal1}
								// openModal2={openModal2}
								setShowNovelties={setShowNovelties}
							/>
						))
					) : (
						<tr>
							<td colSpan="3">No hay Noveades...</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
